import React, { useState } from "react";
import ActionsMenu from "../../shared/components/ActionsMenu";
import ArchiveIcon from "../../shared/Icons/ArchiveIcon";
import EditIcon from "../../shared/Icons/EditIcon";
import PlusCircleIcon from "../../shared/Icons/PlusCircleIcon";
import TrashIcon from "../../shared/Icons/TrashIcon";
import XCloseIcon from "../../shared/Icons/XCloseIcon";

const deleteModalContentStyle = {
  textAlign: 'left',
  border: 'none',
  borderRadius: '12px',
  boxShadow: '0 20px 40px rgba(0, 0, 0, 0.2)',
  maxWidth: '420px',
  width: '90%',
  padding: '0'
};

const VenueActionsMenu = ({
  venueOwnership,
  onAddStage,
  onEdit,
  onDelete,
  onToggleActive,
  csrfToken,
  team,
  openUpwards = false
}) => {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleDeleteClick = (e) => {
    e.preventDefault();
    setConfirmOpen(true);
  };

  const handleCloseDeleteConfirm = () => {
    setConfirmOpen(false);
  };

  return (
    <>
      <ActionsMenu
        triggerIcon={<><EditIcon width="16" height="16" /><span>Edit</span></>}
        buttonClassNames={["team-actions-btn-labeled"]}
        style={{ display: "inline-block" }}
        actions={[
          { label: "Edit Venue", icon: <EditIcon width="16" height="16" />, onClick: () => onEdit(venueOwnership) },
          { label: "Add a Stage", icon: <PlusCircleIcon width="16" height="16" />, onClick: () => onAddStage(venueOwnership) },
          { label: venueOwnership.active ? "Mark Inactive" : "Mark Active", icon: <ArchiveIcon width="16" height="16" />, onClick: () => onToggleActive(venueOwnership) },
          { label: "Remove Venue", icon: <TrashIcon width="16" height="16" />, onClick: handleDeleteClick, danger: true },
        ]}
        openUpwards={openUpwards}
      />

      {confirmOpen && (
        <div className="team-modal-overlay">
          <div className="team-modal" style={deleteModalContentStyle}>
            <div className="team-modal-header">
              <h3 className="team-modal-title">Delete venue?</h3>
              <button
                className="team-modal-close"
                onClick={handleCloseDeleteConfirm}
              >
                <XCloseIcon width="20" height="20" />
              </button>
            </div>
            <div className="team-modal-body">
              <p style={{ marginBottom: '8px' }}>
                Remove <strong>{venueOwnership.name}</strong> from your Opendate account?
              </p>
              <p>This cannot be undone.</p>
            </div>
            <div className="team-modal-footer">
              <button
                className="team-btn-secondary"
                onClick={handleCloseDeleteConfirm}
              >
                Cancel
              </button>
              <button
                className="team-btn-danger"
                onClick={(e) => {
                  e.preventDefault();
                  handleCloseDeleteConfirm();
                  onDelete(csrfToken, team, venueOwnership);
                }}
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VenueActionsMenu;
